/* UPP redesign: header predictive search (snippets/upp-search-bar, sections/upp-predictive-search).
   - Built on first use: the <template> (panel + its styles + the empty state) is cloned on first focus/tap.
   - Desktop (>= 990px): panel under the header. With the header field visible the field is the combobox;
     otherwise (icon) the panel shows its own field. Under 990px: a full sheet under the header bar.
   - Typing (2+ characters, 200 ms debounce, stale requests aborted) fetches the section from /search/suggest;
     a second small request fills "View all N results".
   - Combobox/listbox: arrow keys move through [data-upp-opt] links and product cards, Enter opens, Esc closes. */
(function () {
  'use strict';
  var tpl = document.getElementById('UppPsTemplate');
  if (!tpl) return;

  var SUGGEST = tpl.getAttribute('data-suggest') || '/search/suggest';
  var SEARCH = tpl.getAttribute('data-search') || '/search';
  var hdrForm = document.querySelector('[data-upp-search-form]');
  var hdrInput = hdrForm && hdrForm.querySelector('[data-upp-search-input]');
  var mq = window.matchMedia('(min-width: 990px)');

  var built = false, panel, sheet, body, foot, allLink, status, ownInput, emptyHTML;
  var input = null;          // the active combobox
  var opener = null;         // the icon that opened the panel
  var isOpen = false, opts = [], active = -1;
  var timer = null, ctrl = null, cctrl = null, lastQ = null;

  function build() {
    if (built) return;
    built = true;
    var frag = tpl.content.cloneNode(true);
    var style = frag.querySelector('style');
    if (style) document.head.appendChild(style);
    var empty = frag.querySelector('[data-upp-ps-empty]');
    emptyHTML = empty ? empty.innerHTML : '';
    panel = frag.querySelector('[data-upp-ps-panel]');
    document.body.appendChild(panel);
    sheet = panel.querySelector('[data-upp-ps-sheet]');
    body = panel.querySelector('[data-upp-ps-body]');
    foot = panel.querySelector('[data-upp-ps-foot]');
    allLink = panel.querySelector('[data-upp-ps-all]');
    status = panel.querySelector('[data-upp-ps-status]');
    ownInput = panel.querySelector('.upp-ps2__head [data-upp-search-input]');

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-upp-ps-close]')) { e.preventDefault(); close(true); }
    });
    wireInput(ownInput);
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      // The phone sheet and the icon-opened desktop panel are modal: Tab and Shift+Tab stay inside them. The panel sits
      // at the end of <body>, so letting focus out would drop it in the footer (review 2026-10-18).
      if (e.key === 'Tab' && !panel.classList.contains('is-field')) {
        var f = Array.prototype.filter.call(sheet.querySelectorAll('a[href], button, input, [tabindex="0"]'), function (el) {
          return !el.disabled && el.getAttribute('tabindex') !== '-1' && (el.offsetParent !== null || el.getClientRects().length);
        });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // Tab out of the panel (desktop field mode) closes it.
    panel.addEventListener('focusout', function (e) {
      if (!isOpen || !panel.classList.contains('is-field')) return;
      var to = e.relatedTarget;
      if (to && !panel.contains(to) && !(hdrForm && hdrForm.contains(to))) close(false);
    });
  }

  /* ---------- position ---------- */
  function headerBottom() {
    var h = document.querySelector('.upp-hdr') || document.querySelector('#SiteHeader');
    if (!h) return 0;
    return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
  }
  function place() {
    if (!panel) return;
    var top = headerBottom();
    panel.style.setProperty('--ps-top', top + 'px');
    if (panel.classList.contains('is-sheet')) {
      var vv = window.visualViewport;
      var h = vv ? vv.height + vv.offsetTop - top : window.innerHeight - top;
      panel.style.setProperty('--ps-h', Math.max(200, Math.round(h)) + 'px');
    }
  }
  var placing = false;
  function schedulePlace() {
    if (placing) return;
    placing = true;
    requestAnimationFrame(function () { placing = false; if (isOpen) place(); });
  }
  window.addEventListener('scroll', schedulePlace, { passive: true });
  window.addEventListener('resize', schedulePlace);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedulePlace);
    window.visualViewport.addEventListener('scroll', schedulePlace);
  }

  /* ---------- open / close ---------- */
  function open(fromField) {
    build();
    var desk = mq.matches;
    var field = !!(fromField && desk && hdrInput && hdrForm.offsetParent !== null);
    panel.classList.toggle('is-field', field);
    panel.classList.toggle('is-sheet', !desk);
    if (field) sheet.removeAttribute('aria-modal'); else sheet.setAttribute('aria-modal', 'true');
    input = field ? hdrInput : ownInput;
    if (!field && hdrInput && hdrInput.value && !ownInput.value) ownInput.value = hdrInput.value;
    panel.hidden = false;
    isOpen = true;
    document.documentElement.classList.add('upp-ps-open');
    place();
    if (!desk) document.documentElement.classList.add('upp-ps-lock');
    if (hdrInput) hdrInput.setAttribute('aria-expanded', field ? 'true' : 'false');
    if (!field) input.focus();
    var q = input.value.trim();
    if (q.length >= 2) { lastQ = null; fetchNow(q); } else showEmpty();
  }

  function close(returnFocus) {
    if (!isOpen) return;
    isOpen = false;
    panel.hidden = true;
    document.documentElement.classList.remove('upp-ps-lock', 'upp-ps-open');
    if (hdrInput) { hdrInput.setAttribute('aria-expanded', 'false'); hdrInput.removeAttribute('aria-activedescendant'); }
    abort();
    clearTimeout(timer);
    var wasField = panel.classList.contains('is-field');
    if (returnFocus) {
      if (wasField && hdrInput) hdrInput.focus({ preventScroll: true });
      else if (opener && document.body.contains(opener)) opener.focus({ preventScroll: true });
    }
    opener = null;
  }

  document.addEventListener('pointerdown', function (e) {
    if (!isOpen || panel.classList.contains('is-sheet')) return;
    if (panel.querySelector('[data-upp-ps-sheet]').contains(e.target)) return;
    if (hdrForm && hdrForm.contains(e.target)) return;
    if (e.target.closest('[data-upp-search-open]')) return;
    close(false);
  });

  /* ---------- states ---------- */
  function showEmpty() {
    abort();
    lastQ = '';
    body.innerHTML = emptyHTML;
    body.removeAttribute('aria-busy');
    foot.hidden = true;
    setOptions();
  }

  function abort() {
    if (ctrl) { ctrl.abort(); ctrl = null; }
    if (cctrl) { cctrl.abort(); cctrl = null; }
  }

  function onType() {
    if (!isOpen) open(input === hdrInput);
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { showEmpty(); return; }
    timer = setTimeout(function () { fetchNow(q); }, 200);
  }

  function enc(s) { return encodeURIComponent(s); }

  function fetchNow(q) {
    if (q === lastQ) return;
    lastQ = q;
    abort();
    ctrl = new AbortController();
    body.setAttribute('aria-busy', 'true');
    var url = SUGGEST + '?q=' + enc(q) + '&resources%5Btype%5D=product%2Ccollection%2Cquery%2Cpage%2Carticle' +
      '&resources%5Blimit%5D=4&resources%5Blimit_scope%5D=each&section_id=upp-predictive-search';
    fetch(url, { signal: ctrl.signal, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (q !== lastQ || !isOpen) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = doc.querySelector('[data-upp-ps-results]');
        body.innerHTML = res ? res.outerHTML : '';
        body.removeAttribute('aria-busy');
        var n = res ? parseInt(res.getAttribute('data-count'), 10) || 0 : 0;
        var all = SEARCH + '?q=' + enc(q) + '&options%5Bprefix%5D=last';
        allLink.setAttribute('href', all);
        setAll('View all results', q);
        foot.hidden = n === 0;
        setOptions();
        status.textContent = n === 0 ? 'No exact match for ' + q : (opts.length + ' suggestions available. Use the arrow keys to move through them.');
        if (n > 0) fetchCount(q);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        body.removeAttribute('aria-busy');
      });
  }

  function fetchCount(q) {
    cctrl = new AbortController();
    fetch(SEARCH + '?q=' + enc(q) + '&options%5Bprefix%5D=last&section_id=upp-search-count', { signal: cctrl.signal, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (q !== lastQ || !html) return;
        var m = html.match(/data-upp-search-count="(\d+)"/);
        var n = m ? parseInt(m[1], 10) : 0;
        if (n > 0) setAll('View all ' + n + ' result' + (n === 1 ? '' : 's'), q);
      })
      .catch(function () {});
  }

  // "View all N results for "q"" (the "for …" part is hidden on phones so the button stays one line)
  function setAll(lead, q) {
    allLink.textContent = lead;
    var s = document.createElement('span');
    s.className = 'upp-ps2__allq';
    s.textContent = '\u00a0for “' + q + '”';
    allLink.appendChild(s);
  }

  /* ---------- listbox ---------- */
  function setOptions() {
    opts = Array.prototype.slice.call(body.querySelectorAll('[data-upp-opt], .upp-ps2__prods .upp-card'));
    opts.forEach(function (o, i) {
      o.setAttribute('role', 'option');
      o.setAttribute('id', 'UppPsOpt-' + i);
      o.setAttribute('aria-selected', 'false');
      o.setAttribute('tabindex', '-1');
    });
    active = -1;
    if (input) input.removeAttribute('aria-activedescendant');
    // Phone sheet: the links in the swipe rows (suggestions, collections, popular chips) stay in the tab order, so the
    // rows have focusable content and Tab scrolls them into view (axe scrollable-region-focusable)
    if (panel.classList.contains('is-sheet')) {
      body.querySelectorAll('.upp-ps2__queries [data-upp-opt], .upp-ps2__cols-list [data-upp-opt], .upp-ps2__chips [data-upp-opt]').forEach(function (o) {
        o.setAttribute('tabindex', '0');
      });
    }
  }

  function visible(o) { return o.offsetParent !== null || o.getClientRects().length > 0; }

  function move(d) {
    var list = opts.filter(visible);
    if (!list.length) return;
    var cur = active >= 0 ? list.indexOf(opts[active]) : -1;
    var next = cur + d;
    if (next < 0) next = list.length - 1;
    if (next >= list.length) next = 0;
    if (active >= 0) { opts[active].classList.remove('is-active'); opts[active].setAttribute('aria-selected', 'false'); }
    active = opts.indexOf(list[next]);
    var o = opts[active];
    o.classList.add('is-active');
    o.setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', o.id);
    o.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  function wireInput(el) {
    if (!el) return;
    el.addEventListener('input', function () { input = el; onType(); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!isOpen) { open(el === hdrInput); return; }
        e.preventDefault();
        move(e.key === 'ArrowDown' ? 1 : -1);
      } else if (e.key === 'Enter') {
        if (isOpen && active >= 0 && opts[active]) { e.preventDefault(); window.location.href = opts[active].href; }
      } else if (e.key === 'Escape') {
        if (isOpen) { e.preventDefault(); e.stopPropagation(); close(true); }
      }
    });
  }

  /* ---------- entry points ---------- */
  if (hdrInput) {
    hdrInput.addEventListener('focus', function () { if (!isOpen) open(true); });
    hdrInput.addEventListener('click', function () { if (!isOpen) open(true); });
    hdrInput.addEventListener('blur', function (e) {
      var to = e.relatedTarget;
      if (isOpen && panel.classList.contains('is-field') && to && !panel.contains(to)) close(false);
    });
    wireInput(hdrInput);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-upp-search-open]');
    if (!t) return;
    e.preventDefault();
    if (isOpen) { close(true); return; }
    opener = t;
    open(false);
  });
  mq.addEventListener && mq.addEventListener('change', function () { if (isOpen) close(false); });

  // The cart drawer and the mega menu draw under the panel (z-index 40 on <body>), so the search closes when either
  // opens (review 2026-10-18). theme.js fires drawerOpen; upp-header.js marks the open room with .is-open.
  document.addEventListener('drawerOpen', function () { if (isOpen) close(false); });
  if (window.MutationObserver) {
    var roomsObs = new MutationObserver(function (list) {
      if (!isOpen) return;
      for (var i = 0; i < list.length; i++) {
        if (list[i].target.classList.contains('is-open')) { close(false); return; }
      }
    });
    document.querySelectorAll('[data-upp-room]').forEach(function (li) {
      roomsObs.observe(li, { attributes: true, attributeFilter: ['class'] });
    });
  }
})();
